const colors = {
    "yellow": "#FFD43E",
    "blue": "#0094FF",
    "bg_color": "rgb(10, 10, 10)",
}

export default colors